(function () {
  var OBSERVER_TIMEOUT_MS = 15000;

  function formatSoldCount(value) {
    return new Intl.NumberFormat('en-US').format(value);
  }

  function getSoldCountData() {
    var dataEl = document.querySelector('.product__sold-count-data[data-sold-count]');
    if (!dataEl) return null;

    var count = parseInt(dataEl.dataset.soldCount, 10);
    if (!count || count <= 0) return null;

    return {
      count: count,
      label: dataEl.dataset.soldLabel || '+ sold',
    };
  }

  function injectSoldCount(row, data) {
    if (!row) return;

    var widget = row.querySelector('.yotpo-reviews-star-ratings-widget');
    if (!widget) return;

    var summary = widget.querySelector('.yotpo-sr-bottom-line-summary');
    if (!summary || summary.querySelector('.product__sold-count')) return;

    var divider = document.createElement('span');
    divider.className = 'product__reviews-row__divider';
    divider.setAttribute('aria-hidden', 'true');

    var sold = document.createElement('span');
    sold.className = 'product__sold-count';
    sold.textContent = formatSoldCount(data.count) + data.label;

    summary.appendChild(divider);
    summary.appendChild(sold);
  }

  function initRow(row, data) {
    if (row.querySelector('.yotpo-sr-bottom-line-summary')) {
      injectSoldCount(row, data);
      return;
    }

    var observer = new MutationObserver(function () {
      if (row.querySelector('.yotpo-sr-bottom-line-summary')) {
        injectSoldCount(row, data);
        observer.disconnect();
      }
    });

    observer.observe(row, { childList: true, subtree: true });
  }

  function init() {
    var data = getSoldCountData();
    if (!data) return;

    document.querySelectorAll('.product__reviews-row').forEach(function (row) {
      initRow(row, data);
    });

    var observer = new MutationObserver(function () {
      document.querySelectorAll('.product__reviews-row').forEach(function (row) {
        injectSoldCount(row, data);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
